import useApi from "@/composables/useApi";
import {debounce} from "lodash";
import useGeneralLoading from "@/composables/useGeneralLoading";

export default function useEnergyAdjustmentCoefficients() {
    const {fetchResource, updateResource} = useApi();
    const {isLoading, setLoading} = useGeneralLoading();

    const data = () => ({
        items: [],
        years: [],
        isLoading,
    });

    const updateItemData = debounce((financialItemId, year, volume, price) => {
        updateResource('/v2/finance-and-productivity/adjustment-coefficients', {
            financial_item_id: financialItemId,
            year,
            volume,
            price,
        });
    }, 400);

    const methods = {
        async fetchData() {
            setLoading('fetchData', true);
            const queryString = new URLSearchParams({type: 'energy'}).toString();
            const response = await fetchResource(
                '/v2/finance-and-productivity/adjustment-coefficients?' + queryString
            );

            this.items = response.items;
            this.years = response.years;
            setLoading('fetchData', false);
        },

        handleItemDataChange(financialItemId, year, volume, price) {
            updateItemData(financialItemId, year, volume, price);
        },
    };

    return {
        data,
        methods,
    };
}
